<div class="tw-flex tw-flex-row tw-items-center tw-justify-between">
  <label id="keyOperationModeDeviceLabel" class="tw-mb-0">Lock Buttons</label>
  <mat-slide-toggle
    id="keyOperationModeDevice"
    name="keyOperationModeDevice"
    aria-labelledby="keyOperationModeDeviceLabel"
    [(ngModel)]="keyOperationModeDevice"
  />
</div>
<div class="info text-muted tw-mt-[5px]">
  When enabled, this will block all key operations on the display via the
  physical buttons.
</div>
